import { render } from "./loader.vue?vue&type=template&id=a2ed55f6"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"
script.render = render

export default script